// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  redirectUri: 'https://rcstg.hcr.ny.gov/implicit/callback',
  baseUrlRC: 'https://rcstg.hcr.ny.gov/',
  baseUrl: 'https://rcstgapi.hcr.ny.gov/',
  baseUrlJsonpayloads: 'https://rcstgapi.hcr.ny.gov/JsonPayload/api',
  baseUrlCodeTable: 'https://rcstgapi.hcr.ny.gov/Codes',
  baseUrlRegistration: 'https://rcstgapi.hcr.ny.gov/Registrations',
  baseUrlBuildings: 'https://rcstgapi.hcr.ny.gov/Buildings',
  caseTypeBuildings: 'https://rcstgapi.hcr.ny.gov/Parties/me/buildings',
  baseUrllogging: 'https://rcstgapi.hcr.ny.gov/LoggingApplication/api/Logs',
  baseUrlResources: 'https://rcstgapi.hcr.ny.gov/Resources/api',
  baseUrlParties: 'https://rcstgapi.hcr.ny.gov/Parties',
  basePartyDelegatesUrl: 'https://rcstgapi.hcr.ny.gov/parties/me/delegates',
  baseIncidentsAPI: 'https://rcstgapi.hcr.ny.gov/incidents',
  baseUrlBuildingIdDetails: 'https://rcstgapi.hcr.ny.gov/Buildings/search',
  casesAPI: 'https://rcstgapi.hcr.ny.gov/Parties/me/cases',
  smartyStreetsKey: '27009771635499026',

  oktaIssuer: 'https://login-qa.ny.gov/oauth2/default',
  oktaClientId: '0oa5l4ft60JJHjRIC297',
  oktaScope: 'email profile openid address phone HCR',

  apiURLROCT: 'https://roctstgapi.hcr.ny.gov/',
  apiURLRC: 'https://rcstgapi.hcr.ny.gov/',

  logger: {
    SystemCode: 'ROCT',
    SubSystemCode: 'Printing',
    LogMachine: 'SERVER MACHINE',
    Source: 'DEV MACHINE',
    EnvironmentTypeId: 1
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
